export class OrganizationMapTemplate {
  static getIcon(organization): string {
    return '<div class="organization-icon bubble5"><span>&nbsp;' + organization.name + '</span>&nbsp;</div>';
  }

  static getPopup(organization): string {
    return '<div class="organization-popup">' +
      '<h4>' + organization.organization.name + ' / ' + organization.name + '</h4>' +
      '<div>' + organization.description + '</div>' +
      (organization.address !== null ? '<div><a href="https://www.google.com/maps/place/' + organization.latitude + ',' + organization.longitude + '" target="_blank">' + organization.address + '</a></div>' : '') +
      '<div><a href="https://www.google.com/maps/place/' + organization.latitude + ',' + organization.longitude + '" target="_blank">(' + organization.latitude + ', ' + organization.longitude + ')</a></div>' +
      '</div>';
  }

  static getTooltip(organization): string {
    return OrganizationMapTemplate.getPopup(organization);
  }
}
